/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const LOADING = 'loading';
export const LOADED = 'loaded';
export const FAILED = 'failed';

const slice = createSlice({
  name: 'tab-page',
  initialState: {
    dialogStatus: LOADING,
    shouldShowDialog: false,
    reviewStatus: LOADED,
  },
  reducers: {
    fetchDialogFailure: (state) => {
      state.dialogStatus = FAILED;
    },
    fetchDialogRequest: (state) => {
      state.dialogStatus = LOADING;
    },
    fetchDialogSuccess: (state, { payload }) => {
      state.shouldShowDialog = payload.shouldShowDialog;
      console.log('Slice:', state.shouldShowDialog, payload.shouldShowDialog);
      state.dialogStatus = LOADED;
    },
    fetchReviewFailure: (state) => {
      state.reviewStatus = FAILED;
    },
    fetchReviewRequest: (state) => {
      state.reviewStatus = LOADING;
    },
    fetchReviewSuccess: (state) => {
      state.reviewStatus = LOADED;
    },
  },
});

export const {
  fetchDialogFailure,
  fetchDialogRequest,
  fetchDialogSuccess,
  fetchReviewFailure,
  fetchReviewRequest,
  fetchReviewSuccess,
} = slice.actions;

export const {
  reducer,
} = slice;
